module.exports = __webpack_public_path__ + "media/customizations/regencyatbabcockranch/logo-new-3fc18ba4661faebb30719c394a9dc1f5.png";